// AuthContext.js
import React, { useEffect, useState, createContext, useContext } from 'react'
import { supabase } from '../supabase'


const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const getUser = async () => {
            const { data: { session } } = await supabase.auth.getSession()
            setUser(session?.user || null)
            setLoading(false)
        }
        getUser()

        supabase.auth.onAuthStateChange((_event, session) => {
            setUser(session?.user || null)
        })
    }, [])

    return (
        <AuthContext.Provider value={{ user, loading }}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => useContext(AuthContext)
